import { ActiveSort } from 'store/ui/tables/types';

const DATASET_PAGE_SIZE_KEY = 'ledidi_dataset_page_size';
const DATASET_SORTING_KEY = 'ledidi_dataset_sorting';

export const DEFAULT_PAGE_SIZE = 25;

function getProjectKey(baseKey: string, projectId: string): string {
	return `${baseKey}_${projectId}`;
}

export function getStoredPageSize(): number {
	const stored = localStorage.getItem(DATASET_PAGE_SIZE_KEY);
	if (stored) {
		const parsed = parseInt(stored, 10);
		if (!isNaN(parsed) && parsed > 0) {
			return parsed;
		}
	}
	return DEFAULT_PAGE_SIZE;
}

// Page Size (global, not per project)
export function setStoredPageSize(pageSize: number): void {
	try {
		localStorage.setItem(DATASET_PAGE_SIZE_KEY, pageSize.toString());
	} catch (error) {
		console.warn('Failed to save page size to localStorage:', error);
	}
}

// Sorting
export function getStoredSorting(projectId: string | null): ActiveSort | null {
	if (!projectId) return null;

	try {
		const key = getProjectKey(DATASET_SORTING_KEY, projectId);
		const stored = localStorage.getItem(key);
		if (stored) {
			const parsed = JSON.parse(stored);
			if (parsed === null) return null;
			if (parsed && typeof parsed.column === 'string' && typeof parsed.order === 'string') {
				return parsed as ActiveSort;
			}
		}
	} catch (error) {
		console.warn('Failed to read sorting from localStorage:', error);
	}
	return null;
}

export function setStoredSorting(projectId: string | null, sorting: ActiveSort | null): void {
	if (!projectId) return;

	try {
		const key = getProjectKey(DATASET_SORTING_KEY, projectId);
		if (sorting) {
			localStorage.setItem(key, JSON.stringify(sorting));
		} else {
			localStorage.removeItem(key);
		}
	} catch (error) {
		console.warn('Failed to save sorting to localStorage:', error);
	}
}
